import { canAccessModule } from "./licenseHelpers.mjs";
import { normalizeRoleKey } from "./roleHelpers.mjs";

export const BASE_NAVIGATION_ITEMS = Object.freeze([
  { titleKey: "navigation.home", icon: "mdi-home-city", route: "/", roles: ["admin", "miniadmin", "vacation-default", "crm-default", "ai-default", "recruiter-default", "useradmin-default"] },
  { titleKey: "navigation.hrDashboard", icon: "mdi-view-dashboard-outline", route: "/hr-dashboard", roles: ["admin", "miniadmin", "vacation-hr"] },
  { titleKey: "navigation.dashboard", icon: "mdi-view-dashboard", route: "/dashboard", roles: ["vacation-default", "vacation-user", "vacation-manager", "vacation-director", "vacation-hr"] },
  { titleKey: "navigation.crm", icon: "mdi-clipboard-account-outline", route: "/ncrm", roles: ["admin", "miniadmin", "crm-admin", "crm-operator", "crm-caller", "caller"], moduleKey: "crm" },
  { titleKey: "navigation.aiWorkspace", icon: "mdi-robot-outline", route: "/ai-workspace", roles: ["admin", "miniadmin", "ai-default"] },
  { titleKey: "navigation.users", icon: "mdi-account-key", route: "/users", roles: ["admin", "useradmin-default"] },
  { titleKey: "navigation.admin", icon: "mdi-shield-crown-outline", route: "/admin", literalRoles: ["admin"] },
  { titleKey: "navigation.myData", icon: "mdi-account-check", route: "/me", roles: ["admin", "miniadmin", "vacation-default", "vacation-user", "vacation-manager", "vacation-director", "vacation-hr", "crm-default", "crm-admin", "crm-operator", "crm-caller", "ai-default", "recruiter-default", "recruiter-hr", "recruiter-viewer"] },
  {
    titleKey: "navigation.mainDashboard",
    icon: "mdi-view-dashboard-outline",
    route: "/",
    roles: ["admin", "miniadmin", "vacation-hr", "vacation-default", "vacation-user", "vacation-manager", "vacation-director", "crm-default", "crm-admin", "crm-operator", "crm-caller", "ai-default", "recruiter-default", "recruiter-hr", "recruiter-viewer", "useradmin-default"],
  },
]);

export const NCRM_NAVIGATION_ITEMS = Object.freeze([
  { titleKey: "navigation.crmBoard", icon: "mdi-view-grid-plus-outline", route: "/ncrm", roles: ["admin", "miniadmin", "crm-admin", "crm-operator", "crm-caller", "caller"], moduleKey: "crm" },
  { titleKey: "navigation.ncrmActivities", icon: "mdi-calendar-check-outline", route: "/ncrm/activities", roles: ["admin", "miniadmin", "crm-admin", "crm-operator", "crm-caller", "caller"], moduleKey: "crm" },
  { titleKey: "navigation.ncrmContacts", icon: "mdi-account-multiple", route: "/ncrm/contacts", roles: ["admin", "miniadmin", "crm-admin", "crm-operator"], moduleKey: "crm" },
  {
    titleKey: "navigation.ncrmDataProtection",
    icon: "mdi-shield-account-outline",
    route: "/ncrm/data-protection",
    roles: ["crm-operator"],
    literalRoles: ["admin", "miniadmin", "privacy-manager"],
    roleAccessMode: "any",
    moduleKey: "crm",
  },
  { titleKey: "navigation.ncrmLeads", icon: "mdi-filter-multiple", route: "/ncrm/leads", roles: ["admin", "miniadmin", "crm-admin", "crm-operator", "crm-caller", "caller"], moduleKey: "crm" },
  { titleKey: "navigation.ncrmDeals", icon: "mdi-handshake-outline", route: "/ncrm/deals", roles: ["admin", "miniadmin", "crm-admin", "crm-operator"], moduleKey: "crm" },
  { titleKey: "navigation.ncrmContracts", icon: "mdi-file-document-outline", route: "/ncrm/contracts", roles: ["admin", "miniadmin", "crm-admin", "crm-operator"], moduleKey: "crm" },
  { titleKey: "navigation.ncrmOnboarding", icon: "mdi-rocket-launch-outline", route: "/ncrm/onboarding", roles: ["admin", "miniadmin", "crm-admin", "crm-operator"], moduleKey: "crm" },
  { titleKey: "navigation.ncrmOnboardingTemplates", icon: "mdi-shape-outline", route: "/ncrm/onboarding/templates", roles: ["admin", "miniadmin", "crm-admin", "crm-operator"], moduleKey: "crm" },
  { titleKey: "navigation.ncrmProducts", icon: "mdi-package-variant-closed", route: "/ncrm/products", roles: ["admin", "miniadmin", "crm-admin", "crm-operator"], moduleKey: "crm" },
  {
    titleKey: "navigation.ncrmDataIntegrations",
    icon: "mdi-database-sync",
    route: "/ncrm/data-integrations",
    roles: ["admin", "miniadmin", "crm-admin", "crm-operator", "privacy-manager"],
    literalRoles: ["admin", "miridar"],
    roleAccessMode: "any",
    moduleKey: "crm",
  },
  { titleKey: "navigation.ncrmEmailMarketing", icon: "mdi-email-newsletter", route: "/ncrm/email-marketing", roles: ["admin", "miniadmin", "crm-admin", "crm-operator"], moduleKey: "crm" },
  { titleKey: "navigation.ncrmWorkflows", icon: "mdi-sitemap-outline", route: "/ncrm/workflows", roles: ["admin", "miniadmin", "crm-admin", "crm-operator"], moduleKey: "crm" },
]);

export const ADMIN_NAVIGATION_ITEMS = Object.freeze([
  { titleKey: "navigation.adminContracts", icon: "mdi-file-sign", route: "/admin/contracts", literalRoles: ["admin"] },
  { titleKey: "navigation.adminPlatformEmail", icon: "mdi-email-lock-outline", route: "/admin/platform-email", literalRoles: ["admin"] },
  { titleKey: "navigation.adminAnalytics", icon: "mdi-filter-variant", route: "/admin/analytics", literalRoles: ["admin"] },
  { titleKey: "navigation.adminWorkflows", icon: "mdi-sitemap-outline", route: "/admin/workflows", literalRoles: ["admin"] },
  { titleKey: "navigation.adminOnlineUsers", icon: "mdi-account-clock-outline", route: "/admin/online-users", literalRoles: ["admin"] },
  { titleKey: "navigation.candidates", icon: "mdi-account-group", route: "/Candidati", literalRoles: ["admin"] },
]);

const toRoleSet = (value) => {
  const normalizedSet = new Set();
  const roles = value instanceof Set ? Array.from(value) : Array.isArray(value) ? value : Array.from(value || []);
  roles.forEach((role) => {
    const normalized = normalizeRoleKey(role);
    if (normalized) normalizedSet.add(normalized);
  });
  return normalizedSet;
};

export const filterNavigationItems = (
  items,
  { baseRoles = new Set(), normalizedRoles = new Set(), licenseSnapshot = null } = {}
) => {
  const literalSet = toRoleSet(baseRoles);
  const normalizedSet = toRoleSet(normalizedRoles);
  if (!normalizedSet.size && !literalSet.size) return [];
  return items.filter((item) => {
    const allowedLiteralRoles = Array.isArray(item.literalRoles) ? item.literalRoles : [];
    const allowedRoles = Array.isArray(item.roles) ? item.roles : [];
    const hasLiteralRequirement = allowedLiteralRoles.length > 0;
    const hasRoleRequirement = allowedRoles.length > 0;
    const hasLiteralMatch = hasLiteralRequirement
      ? allowedLiteralRoles.some((role) => literalSet.has(normalizeRoleKey(role)))
      : false;
    const hasRoleMatch = hasRoleRequirement
      ? allowedRoles.some((role) => normalizedSet.has(normalizeRoleKey(role)))
      : false;
    const allowed =
      item.roleAccessMode === "any"
        ? (hasLiteralRequirement || hasRoleRequirement) && (hasLiteralMatch || hasRoleMatch)
        : (!hasLiteralRequirement || hasLiteralMatch) && (!hasRoleRequirement || hasRoleMatch);
    if (!allowed) return false;
    if (
      item.moduleKey &&
      !canAccessModule(item.moduleKey, {
        roleKeys: Array.from(literalSet),
        licenseSnapshot,
        fallbackIfUnknown: true,
      })
    ) {
      return false;
    }
    if (item.route === "/dashboard" && normalizedSet.has("admin")) return false;
    return true;
  });
};

export const buildNavigationDrawerItems = ({
  isAdminRoute = false,
  isNcrmRoute = false,
  baseRoles = new Set(),
  normalizedRoles = new Set(),
  licenseSnapshot = null,
} = {}) => {
  const items = isAdminRoute
    ? [
        BASE_NAVIGATION_ITEMS.find((item) => item.titleKey === "navigation.mainDashboard"),
        ...ADMIN_NAVIGATION_ITEMS,
      ].filter(Boolean)
    : isNcrmRoute
    ? [
        BASE_NAVIGATION_ITEMS.find((item) => item.titleKey === "navigation.mainDashboard"),
        ...NCRM_NAVIGATION_ITEMS,
        BASE_NAVIGATION_ITEMS.find((item) => item.titleKey === "navigation.aiWorkspace"),
        BASE_NAVIGATION_ITEMS.find((item) => item.route === "/me"),
      ].filter(Boolean)
    : BASE_NAVIGATION_ITEMS;
  return filterNavigationItems(items, {
    baseRoles,
    normalizedRoles,
    licenseSnapshot,
  });
};

const asRoleSet = (roles) => (roles instanceof Set ? roles : new Set(roles || []));

// Pure builder for the External Dashboard (`/dashboard`) context menu, given the
// expanded/normalized role set. Extracted from NavigationDrawer.vue for testability.
// Comutarea HR <-> angajat (owner, 2026-10-18): o vede cine are rol HR (`miniadmin` / `vacation-hr`) ȘI
// un spațiu de angajat care nu e gol (rol `vacation-*` + angajat legat de cont). Rolurile sunt cele literale.
export const canSwitchBetweenSpaces = (literalRoles = new Set(), employeeId = null) => {
  const roles = [...asRoleSet(literalRoles)];
  const isHr = roles.includes("miniadmin") || roles.includes("vacation-hr");
  return Boolean(employeeId) && isHr && roles.some((role) => role.startsWith("vacation-"));
};

export const buildExternalDashboardMenu = (normalizedRoles = new Set(), literalRoles = new Set(), employeeId = null) => {
  const roles = asRoleSet(normalizedRoles);
  const items = [];
  if (canSwitchBetweenSpaces(literalRoles, employeeId)) {
    items.push({ id: "hr-space", icon: "mdi-account-switch-outline", titleKey: "externalDashboard.menuItems.hrSpace.label", route: "/hr-dashboard" });
  }
  items.push({ id: "profile-overview", icon: "mdi-account", titleKey: "externalDashboard.menuItems.profile.label" });
  items.push({ id: "my-holidays", icon: "mdi-beach", titleKey: "externalDashboard.menuItems.myHolidays.label" });
  if (roles.has("vacation-manager") || roles.has("vacation-director")) {
    items.push({ id: "team-holidays", icon: "mdi-account-multiple-check", titleKey: "externalDashboard.menuItems.teamHolidays.label" });
  }
  items.push({ id: "my-checklist", icon: "mdi-format-list-checks", titleKey: "externalDashboard.menuItems.checklist.label" });
  items.push({ id: "my-files", icon: "mdi-folder-account", titleKey: "externalDashboard.menuItems.files.label" });
  items.push({ id: "finance", icon: "mdi-cash-multiple", titleKey: "externalDashboard.menuItems.finance.label" });
  items.push({ id: "my-timesheet", icon: "mdi-clock-outline", titleKey: "externalDashboard.menuItems.timesheet.label" });
  if (roles.has("vacation-director")) {
    items.push({ id: "employee-management", icon: "mdi-account-multiple-outline", titleKey: "externalDashboard.menuItems.employeeManagement.label" });
  }
  items.push({ id: "user-account", icon: "mdi-account-key", titleKey: "externalDashboard.menuItems.userAccount.label" });
  return items;
};

// Pure builder for the HR Dashboard (`/hr-dashboard`) context menu, given the
// expanded/normalized role set. Extracted from NavigationDrawer.vue for testability.
// `literalRoles` = rolurile atribuite, fără alias-uri: `useradmin-*` se extinde la `admin` în
// `normalizedRoles`, dar „Gestionare companii” e doar pentru adminul literal (platformă); un tenant
// nou (miniadmin + useradmin-default) nu o vede. Lipsa `literalRoles` ascunde secțiunea (fail-closed).
// Filele „angajat selectat” (finanțe, fișiere): HR le vede numai după ce a deschis un angajat din listă.
// Datele și timesheet-ul personal ale utilizatorului stau în spațiul de angajat (`/dashboard`).
export const HR_EMPLOYEE_TAB_OPTION_IDS = Object.freeze(["finance", "my-files"]);
export const HR_EMPLOYEE_DETAIL_PATH = "/hr-dashboard/employeedetailshr";

export const hasHrEmployeeContext = ({ path = "", query = {} } = {}, selectedEmployeeId = null) => {
  const cleanPath = String(path).replace(/\/+$/, "");
  return (
    Boolean(selectedEmployeeId) &&
    (cleanPath === HR_EMPLOYEE_DETAIL_PATH || (cleanPath === "/hr-dashboard" && HR_EMPLOYEE_TAB_OPTION_IDS.includes(query?.option)))
  );
};

export const buildHrDashboardMenu = (normalizedRoles = new Set(), literalRoles = new Set(), employeeId = null, { hasEmployeeContext = false } = {}) => {
  const roles = asRoleSet(normalizedRoles);
  const isPlatformAdmin = asRoleSet(literalRoles).has("admin");
  const isAdmin = roles.has("admin");
  const isMiniAdmin = roles.has("miniadmin");
  const isHrRole = roles.has("hr") || roles.has("vacation-hr");
  const canSwitch = canSwitchBetweenSpaces(literalRoles, employeeId);
  // Fără spațiu de angajat accesibil (ex. miniadmin fără rol `vacation-*`) elementele proprii rămân în meniul HR.
  const keepOwnItems = Boolean(employeeId) && !canSwitch;
  const items = [];
  if (canSwitch) {
    items.push({ id: "employee-space", icon: "mdi-account-switch-outline", titleKey: "hrDashboard.menuItems.employeeSpace.label", route: "/dashboard" });
  }
  if (isPlatformAdmin) {
    items.push({ id: "company-management", icon: "mdi-domain", titleKey: "hrDashboard.menuItems.companyManagement.label" });
  }
  items.push({ id: "company-board", icon: "mdi-view-dashboard-outline", titleKey: "hrDashboard.menuItems.companyBoard.label" });
  items.push({ id: "employee-management", icon: "mdi-account-multiple-outline", titleKey: "hrDashboard.menuItems.employeeManagement.label" });
  items.push({ id: "checklist", icon: "mdi-format-list-checks", titleKey: "hrDashboard.menuItems.checklist.label" });
  if (keepOwnItems) {
    items.push({ id: "my-data", icon: "mdi-account-circle", titleKey: "hrDashboard.menuItems.myData.label" });
    items.push({ id: "my-timesheet", icon: "mdi-clock-time-four-outline", titleKey: "hrDashboard.menuItems.myTimesheet.label" });
  }
  // Configurarea zilelor nelucrătoare ale companiei (ZileLibere), nu concediul personal: rămâne în meniul HR.
  if (!isHrRole) {
    items.push({ id: "annual-leave", icon: "mdi-beach", titleKey: "hrDashboard.menuItems.annualLeave.label" });
  }
  // Finanțe și Fișiere citesc întâi angajatul selectat; Datele / Timesheet sunt mereu ale utilizatorului.
  if (hasEmployeeContext || keepOwnItems) {
    items.push({ id: "finance", icon: "mdi-cash-multiple", titleKey: "hrDashboard.menuItems.finance.label" });
    items.push({ id: "my-files", icon: "mdi-folder-account", titleKey: "hrDashboard.menuItems.myFiles.label" });
  }
  // Module de recrutare: rute dedicate (pagini complete), lansate din meniul HR Dashboard.
  items.push({ id: "recruitment", icon: "mdi-clipboard-text-outline", titleKey: "hrDashboard.menuItems.recruitment.label", route: "/Recrutare" });
  items.push({ id: "candidates", icon: "mdi-account-group", titleKey: "hrDashboard.menuItems.candidates.label", route: "/Candidati" });
  items.push({ id: "upload-cv", icon: "mdi-file-upload-outline", titleKey: "hrDashboard.menuItems.uploadCv.label", route: "/UploadCV" });
  if (isAdmin || isMiniAdmin) {
    items.push({ id: "users", icon: "mdi-account-key", titleKey: "navigation.users", route: "/users" });
  }
  return items;
};
